import { useRoute } from 'shared/src/hooks/useRoute';
import type { MarketStackParamList } from '../Navigator';

// export type MarketRouteParams = {
//   MarketHome: { marketId: number };
// };

export const useMarketRoute = <Key extends keyof MarketStackParamList>() =>
  useRoute<MarketStackParamList, Key>();
